module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABQCAYAAABrjzfBAAABM0lEQVRoQ+3YQQrCQBBE0el7ufSo4ilceg5PIkYiCUhASU9VtYOUKxfT+vz2Iky0wV8xuK8ZiP5DLuiCaAF03jvogmgBdN476IJoAXTeO+iCaAF03jvogmiBdX6apsP8PiKumc8s2cEFd1xglwxSDtzgZuOttXaKiMeeklLgB9w5Iu57cK+V2Hswe46BkwFZOAmQiaMD2TgqUIGjAVU4ClCJg4FqHASswHUDq3BdwEpcGliNSwF/gfsv4PxrflEx/bhVjUwDq0t2ASuR3cAqJASsQMJANZICVCJpQBWSClQg6UA2UgJkImVAFlIK/IIc4/Jovc8Z+vptgxzzAjN7M/Z+Xr6DCC71yI9+Ue+8C/aWW+dc0AXRAui8d9AF0QLovHfQBdEC6Lx30AXRAui8dxAt+ATvvMZRxRtjDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/xiangzuo_active.png
// module id = c+Me
// module chunks = 1